import { HttpAxiosRequest } from 'src/http/httpAxiosBase'
import { BaseResponse } from 'src/types'
import { z } from 'zod'
import { SistemaTipo } from "../../../../../types/enum/enum"
import { FormFiltros } from '../../../../limites/FiltrosBusqueda'
import { HttpOperacionInforme } from "../../../api/httpOperacionInforme"
import {
    OperacionLCLSCuentaLimitesAprobadosPais,
    OperacionLCLSCuentaLimiteUpdate,
    OperacionLCLSCuentaVista,
    OperacionLCLSInsert,
    schemaListaOperacionLCLSCuentaLimitesAprobadosPais,
    schemaOperacionLCLSCuentaLimiteUpdate,
    schemaOperacionLCLSCuentaVista,
    schemaOperacionLCLSInsert
} from '../types/dto'
import { OperacionLCLS, schemaOperacionLCLS } from '../types/types'

export const getEndpoint = (url = '') => `operaciones/lcls${url}`

export const HttpLCLS = {
    get: (idOperacion: number): Promise<OperacionLCLS> => {
        return HttpAxiosRequest.get(getEndpoint(`/${idOperacion}`))
            .then(response => {
                const parsed = schemaOperacionLCLS.safeParse(response)
                if (!parsed.success) {
                    console.error('Error de validación:', parsed.error.issues)

                    return Promise.reject(new Error('Error de validación.'))
                }

                return parsed.data
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

    post: (operacion: OperacionLCLSInsert): Promise<BaseResponse> => {
        const parsed = schemaOperacionLCLSInsert.safeParse(operacion)
        if (!parsed.success) {
            console.error('Error de validación:', parsed.error.issues)

            return Promise.reject(new Error('Error de validación.'))
        }

        return HttpAxiosRequest.post(getEndpoint(), parsed.data)
            .then(response => {
                return Promise.resolve(response)
            })
            .catch(error => {
                console.error('Error de red:', error)

                return Promise.reject('Error de red.')
            })
    },

    getCuentas: (idOperacion: number): Promise<OperacionLCLSCuentaVista[]> => {
        const url = getEndpoint(`/${idOperacion}/cuentas`);
        const schemaResponse = z.array(schemaOperacionLCLSCuentaVista);

        return HttpAxiosRequest.get(url)
            .then(response => {
                const parsed = schemaResponse.safeParse(response);
                if (!parsed.success) {
                    console.error('Error de validación en getCuentas:', parsed.error.issues);

                    return Promise.reject(new Error('Error de validación.'));
                }

                return parsed.data;
            })
            .catch(error => {
                console.error('Error de red en getCuentas:', error);

                return Promise.reject('Error de red.');
            });
    },

    updateLimite: (idOperacion: number, idLimite: number, limiteUpdate: OperacionLCLSCuentaLimiteUpdate): Promise<BaseResponse> => {
        const parsed = schemaOperacionLCLSCuentaLimiteUpdate.safeParse(limiteUpdate);
        if (!parsed.success) {
            console.error('Error de validación de entrada en updateLimite:', parsed.error.issues);

            return Promise.reject(new Error('Error de validación.'));
        }

        const url = getEndpoint(`/${idOperacion}/cuentas/limites/${idLimite}`);

        return HttpAxiosRequest.put(url, parsed.data)
            .then(response => {
                return Promise.resolve(response);
            })
            .catch(error => {
                console.error('Error de red en updateLimite:', error);

                return Promise.reject('Error de red.');
            });
    },

    getLimitesAprobados: (filtros: FormFiltros): Promise<OperacionLCLSCuentaLimitesAprobadosPais[]> => {
        return HttpAxiosRequest.getWithQueryParamsSerializer(getEndpoint(`/limites`), { ...filtros })
            .then(response => {
                const parsed = schemaListaOperacionLCLSCuentaLimitesAprobadosPais.safeParse(response)

                if (!parsed.success) {
                    console.error('Error de validación en LCLS getLimitesAprobados:', parsed.error.issues)

                    return Promise.reject(new Error('Error de validación.'))
                }

                return parsed.data
            })
            .catch(error => {
                console.error('Error de red en LCLS getLimitesAprobados:', error)

                return Promise.reject('Error de red.')
            })
    },


    descargarInforme: (idOperacion: number): Promise<any> =>
        HttpOperacionInforme.descargarInforme(idOperacion, SistemaTipo.LCLS),

} as const
